import api from 'skin/http';

//Подтверждение кода
function submit(phone, code) {
	return new Promise((resolve, reject) => {
		const opt = {
			method: 'POST',
			url: 'api/other/signup/phone/submit',
			headers: {
				nowait: true
			},
			data: {
				phone,
				code
			}
		}
		api(opt)
		.then(r => {
			if (r.data.error) return reject(r.data.error);
			return resolve();
		})
		.catch(reject)
	})
	
}

export default submit